import React from "react";
import PageWrapper from "../../components/PageWrapper";
import HeroSection from "../../components/Headers";
import CompanyValues from "../../components/CompanyValues";
import AboutCta from "../../components/AboutCta";
import CharityCards from "../../components/CharityCards";
import Seo from "../../components/Seo";

const CharityPage = () => (
    <PageWrapper
		pageTitle="Our Social Responsibility"
		pageDescription="Helping the communities where we operate because making a positive impact is in our DNA"
	>
		<HeroSection
			title="Making a Difference"
			subtitle="Our goal is to make a positive impact in the world by supporting the local communities where we operate. Read more about our charity work."
			subtitle2="At Holborn Assets, we want to do our bit to bring positive change to the world around us. From charity work to projects and other initiatives, our international offices support the local communities where they operate."
		/>
		<CharityCards />
		<AboutCta />
		<CompanyValues />
	</PageWrapper>
);

export const Head = ({ location }) => {
    return (
        <Seo
            title="Our Social Responsibility"
            description="Helping the communities where we operate because making a positive impact is in our DNA"
            canonical={location.pathname}
        />
    );
};

export default CharityPage;